/* eslint-disable max-len */
import React, { useState ,useContext} from 'react'
import AnimatedDeviceList from '../../../../components/Animation/AnimatedDeviceList'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { resetArrays } from '../../../../redux/MultiselectRowsConditionally'
import { useDeviceStatusChangeMutation } from '../../../../features/deviceSlice'
import GlobalContext from '../../../../components/Context/GloablContext'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import { handleSidebarAnimation } from '../../../../redux/commonSlice'
import { convertToPatientTimeZoneDateFormat } from '../../../../CommonMethods/ConvertDatetoPatientTimezone'
import { resetDashboardSearch } from '../../../../redux/dashboardSearchSlice'

const TableBody = ({ tableData,
    indexNum,
    setConfirmationState,
    handleDelete}) => {
    const { setToastmessage,setToastErrorMessage, setIsAdvancedSearchOpen } = useContext(GlobalContext);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [statusChange] = useDeviceStatusChangeMutation()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const selectedRows = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [changeStatusModel, setChangeStatusModel] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('')
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [emptyField, setEmptyField] = useState(false);


    
    // status 
    function transformStatusWord(item){
        if (item === 'out-of-service') {
            return 'out of service';
        } else if (item === 'retired'){
            return 'retired';
        }    
        return item;


    }
    function transformWords(item) {
        // Add your transformation logic here
        if (item === 'active') {
            return 'Activate';
        } else if (item === 'out-of-service') {
            return 'Out of Service';
        } else if (item === 'retired'){
            return 'Retire';
        }   
        return item;
    }
    const handleStatusCloseChangeModal = (value) => {
        setSelectedStatus('');
        setTextAreaMsg("")
        setConfirmationState({});
        setChangeStatusModel(false) 
    }



    const handleStatusChangesingle = async() => {    
        if((textAreaMsg.trim()=== '')){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        const filteredRows = selectedRows.filter(item => item.status !== selectedStatus);
        let body = {
            "device_id": [tableData.device_id],
            "status": selectedStatus,
            "note": textAreaMsg,
        };
        setLoading(true)
        const response = await statusChange({body})
        if(response?.error) {
            setToastErrorMessage(response.error.data.message)
            setChangeStatusModel(false)
            setLoading(false)
        } else{
            if (selectedStatus === 'active') {
                setToastmessage(`Device activated successfully`);
            } else {
                setToastmessage(`Device status changed to ${transformStatusWord(selectedStatus)} successfully`);
            }
            setChangeStatusModel(false)
            setLoading(false)
        }
        setTextAreaMsg('');
        dispatch(resetArrays())
    }

    const handleDeleteItem = () => {
        handleDelete(tableData.device_id)
    }
    
    // const date=convertEpochToDateFormat(tableData?.measurement_date_time,dateformat)

    const date=convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)


    const formattedVitalType = tableData?.reading_type?.replace(/_/g, ' ')?.replace(/\b\w/g, (char) => char.toUpperCase());

    return (
        <>
            <AnimatedDeviceList
                id={tableData?.device_id}
                rowStatus={tableData?.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e) => {
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/dashboard/${tableData?.patient_object_id}/${tableData?.patient_id}`),dispatch(handleSidebarAnimation(false),dispatch(resetDashboardSearch()))

                        // isPatient===undefined?navigate(`/manage-devices/${tableData?._id}`, { state: Array.isArray(location.state) ? '' : { "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '' } }):''
                    }
                }}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start prevent-click  font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {date}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{formattedVitalType==='Spo2' ? "SPO2" : formattedVitalType}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_type}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            <span className={`${tableData?.reading_details?.includes('/') ? "flex" : ""}`}>
                                {tableData?.reading_details?.split('/').map((detail, index, array) => (
                                    <span key={index}>
                                        <span 
                                            className={`${detail === 'Too Low' ? "bg-[#F9E8E9] text-[#D3454D]" : 
                                                detail === 'Too High' ? 'bg-[#EEB9BC] text-[#C81720]' : 
                                                    detail === 'Nominal' ? 'bg-[#9BD6AD] text-[#1A883C]' : 
                                                        (detail === 'Missed Reading' || detail === 'Data Error') ? 'bg-[#E7EAF4] text-[#000000]' : "" } 
                                                        rounded-[28px] px-2 py-1`}
                                        >
                                            {detail}
                                        </span>
                                        {index < array.length - 1 && <span className="mx-1">/</span>}
                                    </span>
                                ))}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.first_name || ''} {tableData?.middle_name || ''} {tableData?.last_name || ''}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.vital_reading_count=== "" || tableData?.vital_reading_count===undefined) ? "-" :tableData?.vital_reading_count} / {(tableData?.vital_total_count=== "" || tableData?.vital_total_count===undefined) ? "-" :tableData?.vital_total_count}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.wellness_reading_count=== "" || tableData?.wellness_reading_count===undefined) ? "-" :tableData?.wellness_reading_count} / {(tableData?.wellness_total_count=== "" || tableData?.wellness_total_count===undefined) ? "-" :tableData?.wellness_total_count}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.wellness_pending_days=== "" || tableData?.wellness_pending_days===undefined) ? "-" :tableData?.wellness_pending_days}</td>
                        <td className="px-[18px] py-2 text-start text-sm  font-normal text-[#031624]">{(tableData?.vital_pending_days=== "" || tableData?.vital_pending_days===undefined) ? "-" :tableData?.vital_pending_days}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.device_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.some(item => item.id === tableData.device_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <button
                                id='view'
                                data-testId={`view-btn-${indexNum}`}
                                onClick={()=>{navigate(`/dashboard/${tableData?.patient_object_id}/${tableData?.patient_id}`),dispatch(handleSidebarAnimation(false)),setIsAdvancedSearchOpen(false)}}
                                className='border border-[#972E4C] rounded-md text-[#972E4C] text-[15px] py-1.5 px-4 leading-[12px]'>
                                View
                            </button>
                        </td>
                    </>

                } />
            {isDeleteOpen &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleDeleteItem}
                        handleClose={() => setIsDeleteOpen(false)}
                        tittle= {'Delete'}
                        message = {`Are you sure you want to delete this device?`}
                        buttonName = {"Yes"}
                        loadingActivation={loading}
                        CancelButton = {"No"}
                    />
                }
            />
            }
            {changeStatusModel && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt
                        emptyField={emptyField}
                        setEmptyField={setEmptyField}
                        setTextAreaMsg={setTextAreaMsg}
                        textAreaMsg={textAreaMsg}
                        handleOnCLickActivate={handleStatusChangesingle}
                        handleClose={handleStatusCloseChangeModal}
                        tittle= {transformWords(selectedStatus)}
                        message = {selectedStatus=== "active" ? `Are you sure you want activate this device?` :`Are you sure you want to change the status of this device to ${transformStatusWord(selectedStatus)}?`}
                        // textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                        buttonName = {'Yes'}
                        loadingActivation={loading}
                        CancelButton={'No'}
                        disabled={loading}
                    />
                }
            /> 
            }
        </>
    )
}

export default TableBody